<template>
<div class="chapter">
<div class="inner_page">
<p class="h1">A<span class="small">CKNOWLEDGEMENTS</span></p>
<p class="noindent">The author would like to acknowledge the following people for their encouragement and support: D-B Garvin, editor of <i>Historical New Hampshire</i>, for her ongoing help in getting Ruth’s story told; Patti Craig, Deb Child and Courtney MacClachlan, for their encouragement, for joining me on field trips and for reading and commenting on the work in progress; Thomas Hardiman, for enduring multiple versions of the book and offering wise commentary; Susan DeGaia, for reading the text and for her kind remarks; Dennis Robinson, for introducing me and my subject to the press and publisher; Andrew Leibs, for his friendship and support through crises of confidence; and friends and family, for their “yes you can” attitude.</p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// acknowledgements.vue?44b03384